import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Auth, Hub } from 'aws-amplify';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import ThemeProvider from './features/commons/theme-provider';
import Header from './features/header/Header';
import Footer from './features/footer/Footer';
import { AuthContext } from './features/auth/context/auth';
import Login from './features/auth/Login';
import LocalRedirect from './features/auth/LocalRedirect';
import Unauthorized from './features/auth/Unauthorized';
import ScrollToTop from './features/scrollToTop/ScrollToTop';
import getCognitoUserPool from './functions/getCognitoUserPool';
import getCognitoCallbackUrl from './functions/getCognitoCallbackUrl';
import SessionTimeout from './features/session/SessionTimeout';

import Main from './features/home/Main';

function App() {
  const existingUser = JSON.parse(localStorage.getItem('nss_user'));
  const [user, setUser] = useState(existingUser);
  const [location, setLocation] = useState();
  const existingUserAttributes = JSON.parse(
    localStorage.getItem('nss_user_attributes')
  );
  const [userAttributes, setUserAttributes] = useState(existingUserAttributes);

  const updateUserAttributes = async () => {
    try {
      const authenticatedUser = await Auth.currentAuthenticatedUser();

      // example profile from cognito with one group is "role1"
      // example profile from cognito with multiple groups is "[role1, role2, role3]"
      // this removes the spaces and brackets so we can parse it
      if (authenticatedUser.attributes.profile) {
        let profile = authenticatedUser.attributes.profile.replaceAll(' ', '');
        profile = profile.replaceAll('[', '');
        profile = profile.replaceAll(']', '');
        const userRoles = profile.split(',');
        authenticatedUser.attributes.profile = userRoles;
      }

      localStorage.setItem(
        'nss_user_attributes',
        JSON.stringify(authenticatedUser.attributes)
      );
      setUserAttributes(authenticatedUser.attributes);
    } catch {
      // do nothing
    }
  };

  useEffect(() => {
    Hub.listen('auth', ({ payload: { event, data } }) => {
      switch (event) {
        case 'signIn':
          localStorage.setItem('nss_user', JSON.stringify(data));
          setUser(data);
          updateUserAttributes();
          break;
        case 'customOAuthState':
          setLocation(JSON.parse(decodeURIComponent(data)).originalUri);
          break;
        default:
      }
    });
  }, []);

  const cognitoUserPool = getCognitoUserPool();
  const CognitoCallbackUrl = getCognitoCallbackUrl();
  Auth.configure({
    region: process.env.REACT_APP_AWS_REGION,
    userPoolId: cognitoUserPool.UserPoolId,
    userPoolWebClientId: cognitoUserPool.ClientId,

    // Cognito Hosted UI configuration
    oauth: {
      domain: cognitoUserPool.domain,
      scope: ['email', 'openid', 'aws.cognito.signin.user.admin', 'profile'],
      redirectSignIn: CognitoCallbackUrl,
      redirectSignOut: CognitoCallbackUrl,
      responseType: 'code',
    },
  });

  const queryClient = new QueryClient();

  return (
    <AuthContext.Provider
      value={{
        user,
        userAttributes,
      }}
    >
      <Router>
        <ThemeProvider>
          <ToastContainer closeOnClick pauseOnHover hideProgressBar />
          <ScrollToTop />
          <SessionTimeout />
          <div className="site">
            <QueryClientProvider client={queryClient}>
              <Header />
              <LocalRedirect location={location} />
              <div className="content" style={{ marginTop: '1em' }}>
                <Switch>
                  <Route exact path="/" component={Main} />
                  <Route path="/login" component={Login} />
                  <Route path="/unauthorized" component={Unauthorized} />
                </Switch>
              </div>
            </QueryClientProvider>
            <Footer />
          </div>
        </ThemeProvider>
      </Router>
    </AuthContext.Provider>
  );
}

export default App;
